module.exports = __webpack_public_path__ + "img/cargo-wagon-2.4c27ad9e.png";